module.exports = __webpack_public_path__ + "assets/eye.c1d37928.svg";